import React, { useEffect, useState } from "react";
import classNames from "classnames";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import { ExitToApp } from "@material-ui/icons";
import Toolbar from "@material-ui/core/Toolbar";
import {
  Avatar,
  Button,
  Menu,
  MenuItem,
  createMuiTheme,
  MuiThemeProvider,
  FormControl,
  Select
} from "@material-ui/core";
import API, { graphqlOperation } from "@aws-amplify/api";

import {
  getBotInformations,
  listAdminPermissionss
} from "../../../graphql/queries";
import { messageDataFont } from "../../inputData/inputContant";
import withRoot from "../../../withRoot";

const theme = createMuiTheme({
  overrides: {
    MuiButton: {
      label: {
        fontSize: "0.3rem",
        color: "white"
      }
    }
  }
});

interface IAppBarProps {
  classes: any;
  leftDrawer: { leftDrawerOpen: Boolean; setLeftDrawerOpen: Function };
  rightDrawer: { rightDrawerOpen: Boolean; setRightDrawerOpen: Function };
  // signOut: any;
}

const PrimaryAppBar: React.FC<IAppBarProps> = props => {
  const {
    classes,
    leftDrawer: { leftDrawerOpen }
    // signOut
  } = props;
  const [botInfo, setBotInfo]: any = useState({});
  const [authBucket, setAuthBucket] = React.useState("18");
  const [adminPermission, setAdminPermission]: any = useState();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [
    anchorElLogout,
    setAnchorElLogout
  ] = React.useState<null | HTMLElement>(null);
  const [anchorElFont, setAnchorElFont] = React.useState<null | HTMLElement>(
    null
  );

  useEffect(() => {
    getAdminPermission();
    listExpert();
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickFont = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElFont(event.currentTarget);
  };

  const handleCloseFont = (event: any) => {
    setAuthBucket(event.target.value);
    // {localStorage.getItem("Fontsize") !== undefined ? setAuthBucket(`${localStorage.getItem('Fontsize')}`) : setAuthBucket(event.target.value)}
    localStorage.setItem("Fontsize", event.target.value);
    // window.location.reload();
    setAnchorElFont(null);
  };

  const handleClickLogout = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElLogout(event.currentTarget);
  };

  const handleCloseLogout = () => {
    setAnchorElLogout(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const listExpert = async () => {
    const userMutation: any = await API.graphql(
      graphqlOperation(getBotInformations, {
        filter: {
          id: { eq: "69238cfb-8f29-471c-bf4b-920a88e2f468" }
        },
        limit: 100
      })
    );
    const mutationResponse = await Promise.all([userMutation]);
    let DataMain = mutationResponse[0].data.listBotInformations.items[0];
    setBotInfo(DataMain);
  };

  const getAdminPermission = async () => {
    const userMutation: any = await API.graphql(
      graphqlOperation(listAdminPermissionss, {
        filter: { roleName: { contains: "HoneyCode glossary chat" } },
        limit: 100
      })
    );
    const mutationResponse = await Promise.all([userMutation]);
    let DataMainSet = mutationResponse[0].data.listAdminPermissions.items[0];
    setAdminPermission(DataMainSet);
  };

  return (
    <AppBar
      position="fixed"
      className={classNames(
        classes.appBar,
        leftDrawerOpen && classes.appBarShift
      )}
    >
      <Toolbar disableGutters={!leftDrawerOpen} className={classes.toolbar}>
        {/* <Avatar src="Tehillim.png" className={classes.Imgmain} /> */}
        <Avatar src={botInfo && botInfo.BotLogo} className={classes.Imgmain}/>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          className={classes.title}
        >
          {botInfo && botInfo.BotDisplayName}
          {/* Tehillim Glossary Chat */}
        </Typography>
        {/* <FormControl className={classes.inputBucketflow} >
          <Select
            id="demo-simple-select"
            value={authBucket}
            onChange={handleCloseFont}
            style={{ color: "black", backgroundColor:"white", borderRadius:'3px'}}
          >
            {messageDataFont.map((item: any, index: any) => (
              <MenuItem key={index} value={item} >
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
        <MuiThemeProvider theme={theme}>
          {/* <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClickLogout}
                style={{ outline: "0px" }}
              >
                Logout
              </Button>
			  <Menu
            id="simple-menu"
            anchorEl={anchorElLogout}
            keepMounted
            open={Boolean(anchorElLogout)}
            onClose={handleCloseLogout}
          >
            <MenuItem onClick={signOut}>
			<ExitToApp /> Logout
            </MenuItem>
          </Menu> */}
          {adminPermission &&
            adminPermission.Permissions.indexOf("editHomeHelpPage") > -1 && (
              <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
                style={{ outline: "0px" }}
              >
                EditPage
              </Button>
            )}
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose}>
              <a
                href="https://ac.page.bot/edit/honeycode-glossary-chat-home"
                target="_blank"
              >
                Home
              </a>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <a
                href="https://ac.page.bot/edit/honeycode-glossary-chat-help"
                target="_blank"
              >
                Help
              </a>
            </MenuItem>
          </Menu>
        </MuiThemeProvider>
      </Toolbar>
    </AppBar>
  );
};

export default withRoot(PrimaryAppBar);
